"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_EVENT_ENUM = exports.SERVER_EVENT_ENUM = void 0;
var SERVER_EVENT_ENUM;
(function (SERVER_EVENT_ENUM) {
    SERVER_EVENT_ENUM["SEGMENT_UPDATED"] = "SEGMENT_UPDATED";
    SERVER_EVENT_ENUM["WORKPLACE_UPDATED"] = "WORKPLACE_UPDATED";
    SERVER_EVENT_ENUM["NOTIFICATION"] = "NOTIFICATION";
    SERVER_EVENT_ENUM["WHO_ARE_YOU"] = "WHO_ARE_YOU";
    SERVER_EVENT_ENUM["HI"] = "HI";
    SERVER_EVENT_ENUM["NEW_CHAT_MESSAGE"] = "NEW_CHAT_MESSAGE";
    SERVER_EVENT_ENUM["APPLICATION_STATUS_UPDATE"] = "APPLICATION_STATUS_UPDATE";
})(SERVER_EVENT_ENUM = exports.SERVER_EVENT_ENUM || (exports.SERVER_EVENT_ENUM = {}));
var CLIENT_EVENT_ENUM;
(function (CLIENT_EVENT_ENUM) {
    CLIENT_EVENT_ENUM["I_AM"] = "I_AM";
})(CLIENT_EVENT_ENUM = exports.CLIENT_EVENT_ENUM || (exports.CLIENT_EVENT_ENUM = {}));
